import React from "react";

const AboutSection = () => {
  return (
        <div className="min-h bg-gray-900 bg-opacity-0 text-white px-6 py-12">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold mb-6 text-center">About the Artist</h1>
        <p className="mb-4 text-lg text-gray-300">
          Ilja is a passionate 3D modeler with a love for detail, storytelling, and artistic expression.
          Every project is a blend of creativity and technical precision.
        </p>
        <p className="mb-4 text-lg text-gray-300">
          This site showcases a growing portfolio of digital works, from character design to product visualization.
        </p>
        <p className="text-lg text-gray-300">
          When not modeling, Ilja enjoys gaming, exploring design trends, and learning new creative tools.
        </p>
      </div>
    </div>
  );
};

export default AboutSection;
